module.exports = __webpack_public_path__ + "static/media/ht.1c12655d.png";